import React from 'react';

import { message } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { T } from 'react-translator-component';
import styled from 'styled-components';

import { setIsUserAuthenticated } from '../../redux/actions';
import { logout } from '../../services/authentication';
import { createDocument } from '../../services/documents';

const UserLogoutButton = styled.div``;

const logoutAction = async (dispatch: any, isUserAuthenticated: boolean) => {
  if (isUserAuthenticated) {
    const res = await createDocument(null, 'logout');
    if (res) {
      logout();
      dispatch(setIsUserAuthenticated(false));
      message.success('Logout efetuado com sucesso!');
    }
  }
};

const UserLogoutButtonLink = () => {
  const dispatch = useDispatch();

  const isUserAuthenticated = useSelector((state: any) => state.user?.isUserAuthenticated);
  return (
    <UserLogoutButton
      onClick={() => {
        logoutAction(dispatch, isUserAuthenticated);
      }}
    >
      {T('Logout')}
    </UserLogoutButton>
  );
};

export default UserLogoutButtonLink;
